import { UseCase } from './UseCase';

let REQUEST_MAPS: Map<Function, Map<string, Promise<any>>>;

export abstract class DebounceUseCase<P, R> implements UseCase<P, Promise<R>> {
    private requestMap: Map<string, Promise<R>>;

    constructor() {
        const ctor = this.constructor;
        if (!REQUEST_MAPS) {
            // Lazily create cache incase we need to wait for Map polyfill
            REQUEST_MAPS = new Map<Function, Map<string, Promise<any>>>();
        }

        if (!REQUEST_MAPS.has(ctor)) {
            REQUEST_MAPS.set(ctor, new Map());
        }

        this.requestMap = <Map<string, Promise<R>>>REQUEST_MAPS.get(ctor);
    }

    execute(params: P): Promise<R> {
        if (params && params['useCache'] === false) {
            return this.debounceExecute(params)
                .then((result) => {
                    return result;
                })
                .catch((error) => {
                    throw error;
                });
        } else {
            let key: string;
            try {
                key = JSON.stringify(params) || 'default';
            } catch (err) {
                key = 'default';
            }

            if (!this.requestMap.has(key)) {
                this.requestMap.set(
                    key,
                    this.debounceExecute(params)
                        .then((result) => {
                            this.requestMap.delete(key);
                            return result;
                        })
                        .catch((error) => {
                            this.requestMap.delete(key);
                            throw error;
                        })
                );
            }

            return <Promise<R>>this.requestMap.get(key);
        }
    }

    protected abstract debounceExecute(params: P): Promise<R>;
}
